// header周り
const header = () => {
	const header = document.querySelector('.l-header');
	if(header !== null){
		const path = location.pathname.split('/')[1];
		const gnav_btn = document.querySelector('.l-header__gnav__btn');
		const item = document.querySelectorAll('.l-header__gnav__list__item');
		const item_btn = document.querySelectorAll('button.l-header__gnav__list__item__btn');
		
		if(window.innerWidth < 768 ){ //SPのみ
			// Gナビ開閉
			gnav_btn.addEventListener('click', ()=>{
				document.querySelector('.l-header__gnav').classList.toggle('is-show');
				gnav_btn.querySelector('.c-icon').classList.toggle('c-icon--gnav_menu');
				gnav_btn.querySelector('.c-icon').classList.toggle('c-icon--gnav_close');
				document.body.classList.toggle('is-fixed');
			});

			// Gナビ内部アコーディオン
			for (let i = 0; i < item_btn.length; i++) {
				item_btn[i].addEventListener('click', ()=>{
					slide_toggle(item_btn[i].nextElementSibling);
					item_btn[i].closest('.l-header__gnav__list__item').classList.toggle('is-show');
				});
			}
		}
		if(window.innerWidth >= 768 ){ //PCのみ
			// メガメニュー
			for (let i = 0; i < item_btn.length; i++) {
				item_btn[i].addEventListener('click', ()=>{
					let flg = item_btn[i].closest('.l-header__gnav__list__item').classList.contains('is-show');
	
					for (let j = 0; j < item_btn.length; j++) {
						item_btn[j].nextElementSibling.style.display = 'none';
						item_btn[j].closest('.l-header__gnav__list__item').classList.remove('is-show');
					}
					if(!flg){
						slide_toggle(item_btn[i].nextElementSibling);
						item_btn[i].closest('.l-header__gnav__list__item').classList.toggle('is-show');
					}
				});
			}
	
			// カレント処理
			for (let i = 0; i < item.length; i++) {
				item[i].querySelector('.l-header__gnav__list__item__btn').classList.remove('is-current');
				if(item[i].getAttribute('data-path') === path){
					item[i].querySelector('.l-header__gnav__list__item__btn').classList.add('is-current');
				}
			}
	
			// スクロール時
			window.addEventListener('scroll', ()=>{
				if(0 < document.documentElement.scrollTop){
					header.classList.add('is-scroll');
				} else {
					header.classList.remove('is-scroll');
				}
	
				// fixed時の横スクロール処理
				header.style.left = -document.documentElement.scrollLeft + 'px';
			});
		}

	}
}